import { render, staticRenderFns } from "./AdminPermissionList.vue?vue&type=template&id=3c486664&scoped=true&"
import script from "./AdminPermissionList.vue?vue&type=script&lang=js&"
export * from "./AdminPermissionList.vue?vue&type=script&lang=js&"
import style0 from "./AdminPermissionList.vue?vue&type=style&index=0&id=3c486664&scoped=true&lang=css&"
import style1 from "./AdminPermissionList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c486664",
  null
  
)

export default component.exports